// extracted by mini-css-extract-plugin
export default {"imageContainer":"X1-z","summaryPar":"Y1-z","ratingCategories":"Z1-z","reviewerInfo":"_1-z","reviewTypes":"a2-z","expanded":"b2-z"};